import { useTranslation } from 'react-i18next';
import { Card, Group, Stack, Text } from '@mantine/core';
import { IconBuildingBank } from '@tabler/icons-react';
import { formatMoney } from '@/lib/format';
import type { ExchangeSellOrientation } from '@/types/sell';

interface ExchangeOrientationCardProps {
  readonly orientation: ExchangeSellOrientation;
}

// Ориентир биржевого продавца: лучшая нетто-цена FCA у ворот (его выручка) + терминал-источник. Без CTA
// сделки — сделки на бирже заключаются в ходе торгов, вручную заключить нельзя.
export default function ExchangeOrientationCard({ orientation }: ExchangeOrientationCardProps) {
  const { t } = useTranslation();
  return (
    <Card withBorder padding="md" bg="lime.0" style={{ borderColor: 'var(--mantine-color-brand-4)' }}>
      <Group justify="space-between" wrap="wrap" gap="sm">
        <Group gap={8} wrap="nowrap" style={{ minWidth: 0 }}>
          <IconBuildingBank size={18} color="var(--mantine-color-brand-6)" style={{ flexShrink: 0 }} />
          <Stack gap={0} style={{ minWidth: 0 }}>
            <Text size="sm" c="gray.8">
              {t('app.sell.exchange.orientationTitle')}
            </Text>
            <Text size="xs" c="gray.6">
              {t('app.sell.exchange.orientationTerminal', { terminal: orientation.terminal })}
            </Text>
          </Stack>
        </Group>
        <Stack gap={0} align="flex-end">
          <Text fw={700} fz={20} c="brand.9">
            {formatMoney(orientation.fcaPricePerTon)}
          </Text>
          <Text size="xs" c="gray.7">
            {t('app.sell.rubPerTon')}
          </Text>
        </Stack>
      </Group>
    </Card>
  );
}
